import React from 'react';
import HtmlEditor from './HtmlEditor';
import HtmlDisplay from './HtmlDisplay';

export default function Html({
  html,
  nodeKey,
  updateHtml,
  isEditing,
  escapeUp,
  escapeDown,
  removeNode,
}) {
  return (
    <>
      {isEditing ? (
        <HtmlEditor
          html={html}
          nodeKey={nodeKey}
          updateHtml={updateHtml}
          escapeUp={escapeUp}
          escapeDown={escapeDown}
          removeNode={removeNode}
        />
      ) : (
        <div>
          <HtmlDisplay html={html} />
          <div className="absolute inset-0 z-50 mt-0"></div>
        </div>
      )}
    </>
  );
}
